import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { HttpClient } from '@angular/common/http';
import { Permissions } from '../models/permissions';
import { Role } from '../models/role';
import { Ability } from '../models/ability';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private http:HttpClient) { }

  async loadPermissions(user: User) : Promise<Permissions> {
    return this.http.get<Permissions>(`/api/auth/${user.id}/all`)
      .toPromise();
  }

  async loadRoleAbilities (role: Role) : Promise<Ability[]> {
    return this.http.get<Ability[]>(`/api/auth/${role.id}/abilities`)
      .toPromise();
  }

  async addRoleToUser(role:Role, user:User) : Promise<void> {
    return this.http.post<void>(`/api/auth/assign/role/user`, {id_1: role.id, id_2: user.id})
      .toPromise();
  }

  async removeRoleToUser(role:Role, user:User) : Promise<void> {
    return this.http.post<void>(`/api/auth/retract/role/user`, {id_1: role.id, id_2: user.id})
      .toPromise();
  }

  async addAbilityToUser(ability:Ability, user:User) : Promise<void> {
    return this.http.post<void>(`/api/auth/allow/ability/user`, {id_1: ability.id, id_2: user.id})
      .toPromise();
  }

  async addAbilityToRole(ability:Ability, role:Role) : Promise<void> {
    return this.http.post<void>(`/api/auth/allow/ability/role`, {id_1: ability.id, id_2: role.id})
      .toPromise();
  }

  async removeAbilityToUser(ability:Ability, user:User) : Promise<void> {
    return this.http.post<void>(`/api/auth/disallow/ability/user`, {id_1: ability.id, id_2: user.id})
      .toPromise();
  }

  async blockAbilityToUser(ability:Ability, user:User) : Promise<void> {
    return this.http.post<void>(`/api/auth/forbid/ability/user`, {id_1: ability.id, id_2: user.id})
      .toPromise();
  }

  async unblockAbilityToUser(ability:Ability, user:User) : Promise<void> {
    return this.http.post<void>(`/api/auth/unforbid/ability/user`, {id_1: ability.id, id_2: user.id})
      .toPromise();
  }
}
